export const pathChecker = path => {
  try {
    const pathSplit = path.split('/');
    return `/${pathSplit[3]}`;
  } catch (err) {
    return '';
  }
};

export const passParamsToPath = (path, params) => {
  if (path && params) {
    let newPath = path;
    const arrayPropertyNames = Object.getOwnPropertyNames(params);
    arrayPropertyNames.forEach(name => newPath = newPath.replace(`:${name}`, params[name]));
    return newPath;
  }
  return null;
};
